import { Switch } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import Theme from "../../../../../../../styles/Theme/Theme";
import { SelectAtomic } from "../../../../../Atomics/SelectAtomic";
import { filtersTypes, getDefaultFilterValue, getFilterNotSelected } from "../../ItemsConfig/ItemsConfig";
import FamilyTypeText from "./FamilyTypeText/FamilyTypeText";

const LabelContainer = styled.label`
  font-weight: 500;
  display: flex;
  align-items: center;
  height: 35px;
  gap: 20px;
  justify-content: start;
`;

const FamilyTypeFilter = ({ familyOptions, typeOptions, setSelectedFilter, selectedFilter, isFilterDisabled, isForModal,
  isDefaultSelectionRequired, width
}) => {

  const { t } = useTranslation();

  const isFamilyOptionsEmpty = !familyOptions || familyOptions?.length === 0;
  const isTypeOptionsEmpty = !typeOptions || typeOptions?.length === 0;
  const isFamilyAndTypeOptionsEmpty = isFamilyOptionsEmpty && isTypeOptionsEmpty;

  /**
     * Update selected filter based on the filter chosen
     * Puts the other filter to null
     * @param {String} filter - The filter that was chosen
     * @param {String} value - The value of the chosen filter
  */
  const updateSelectedFilter = (filter, value) => {
    if (filter === filtersTypes.family || filter === filtersTypes.type) {
      setSelectedFilter({ selected: filter, value: value });
    }
  }

  return (
    <div
      style={{ width: width || "100%" }}
    >
      <LabelContainer
        style={{ marginLeft: isForModal ? Theme.spacing.s03 : 0 }}
      >
        <FamilyTypeText
          isTextForModal={isForModal}
          disable={isFamilyOptionsEmpty}
        >
          {t("Family")}
        </FamilyTypeText>
        <Switch
          checked={selectedFilter?.selected === filtersTypes.type}
          style={{
            backgroundColor: Theme.color["blue-4"]
          }}
          disabled={
            isFilterDisabled ||
            !familyOptions ||
            !typeOptions ||
            typeOptions?.length === 0
          }
          onChange={() => {
            const filterNotSelected = getFilterNotSelected(selectedFilter);
            if (!isDefaultSelectionRequired) {
              updateSelectedFilter(filterNotSelected, null);
            } else {
              const defaultFilterNotSelectedValue = getDefaultFilterValue(
                filterNotSelected,
                typeOptions,
                familyOptions
              );
              updateSelectedFilter(
                filterNotSelected,
                defaultFilterNotSelectedValue
              );
            }
          }}
          size="small"
        />
        <FamilyTypeText
          isTextForModal={isForModal}
          disable={isTypeOptionsEmpty}
        >
          {t("Type")}
        </FamilyTypeText>
      </LabelContainer>
      <SelectAtomic
        isModal={isForModal}
        optionsData={
          selectedFilter?.selected === filtersTypes.type
            ? typeOptions
            : familyOptions
        }
        fullWidth={true}
        defaultValue={selectedFilter.value}
        handleOptionsChange={(value) =>
          updateSelectedFilter(selectedFilter.selected, value)
        }
        isToDisable={isFilterDisabled || isFamilyAndTypeOptionsEmpty}
        placeholder={
          <span style={{ color: "lightgrey" }}>
            {t("Select Value")}
          </span>
        }
      />
    </div>
  );
};

export default FamilyTypeFilter;
